import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { TableCell } from "@mui/material";
import React from "react";
import { Button } from "../../Button/Button";
import { Messages } from "../Messages";
import { stopPropagation } from "../utils/stopPropagation";
import { dataGridStyles } from "./DataGrid/DataGridStyles";
const getGroupHeader = (columns, row) => {
    const groupColumn = columns.filter((col) => col.id == row.groupByID)[0];
    if (groupColumn.groupHeaderRow) {
        return groupColumn.groupHeaderRow(row.subRows);
    }
    else {
        return row.groupByVal;
    }
};
export default function GroupHeaderCell(props) {
    const { columns, row, rowRef, focusedRowId } = props;
    //Identify from which column should the groupHeaderRow be rendered from
    const groupHeader = getGroupHeader(columns, row);
    return (React.createElement(TableCell, { "data-testid": "data-grid-group-row", component: "div", key: `${row.index}-group`, sx: {
            ...dataGridStyles.groupedCell,
            //This allows us to override the mui button styling
            "& .MuiIconButton-root": {
                padding: 0,
                marginTop: "-1px"
            }
        } },
        React.createElement("span", { style: { width: 10 * row.depth } }),
        React.createElement("div", { onFocus: stopPropagation, onClick: stopPropagation, onMouseDown: (e) => {
                stopPropagation(e);
                e.preventDefault();
            } },
            React.createElement(Button, { ...row.getToggleRowExpandedProps(), title: row.isExpanded ? Messages.COLLAPSE_ROW_GROUP.getMessage() : Messages.EXPAND_ROW_GROUP.getMessage(), onClick: (e) => {
                    e.stopPropagation();
                    row.toggleRowExpanded();
                    if (row.subRows.find((r) => r.id == focusedRowId)) {
                        //When the group the currently focused row belongs to is collapsed, set the focus on the group header instead
                        rowRef?.current?.focus({ preventScroll: true });
                    }
                }, iconButton: true, startIcon: row.isExpanded ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null), "aria-label": Messages.TOGGLE_EXPAND_ROW_GROUP.getMessage(), variant: "plain", rounded: true, style: { paddingRight: 5 } })),
        groupHeader));
}
